export const PlayStoreURL = 'https://play.google.com/store/apps/details?id=com.trellish.app'
export const AppStoreURL = 'https://apps.apple.com/us/app/trellish-gift-stocks-etfs/id6443480118'

export const AppStoreButton = 'https://cmsphoto.ww-cdn.com/superstatic/41269/art/grande/17237224-21754913.jpg'
export const PlayStoreButton = 'https://www.lawabidingbiker.com/wp-content/uploads/2018/08/google-play-app-store-button-android-.png' 
